//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import YoutubeIframe from '@/components/UI/YoutubeIframe'

export default {
  name: 'VideoSection',
  components: {
    YoutubeIframe,
  },
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
    videoUrl: {
      type: String,
      required: true,
      default: '',
    },
  },
}
